// CORES DO PROJETO — onde mexer:
//  • Cores de CSS (hex nos blocos <style>): centralizadas em
//    src/assets/styles/tokens.css como variáveis --ds-* — mude lá e reflete
//    em todos os componentes.
//  • Cores nomeadas do Vuetify (color="primary"/"success"/...): o theme abaixo.
//    Os valores espelham os tokens (ex.: primary == --ds-primary #1F4D3F).
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/es5/locale/pt";
import { cspNonce } from "@/utils/cspNonce";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pt },
    current: "pt",
  },
  theme: {
    // SALVIA-746: o tema vira um <style> criado em tempo de execução; sem o
    // nonce, a CSP o bloqueia e a interface perde todas as cores do tema.
    options: { cspNonce: cspNonce() },
    themes: {
      light: {
        // Paleta Salvia — verde-médio principal, pinheiro de apoio, areia acento
        primary: "#3E8E73", // verde-médio
        secondary: "#1F4D3F", // pinheiro
        accent: "#E8A04B", // areia (acento pontual)
        error: "#FF5252",
        info: "#1F4D3F",
        success: "#4CAF50",
        warning: "#FFC107",

        // Suas cores customizadas
        white: "#FFFFFF",
        grayLight: "#F5F5F5",
        grayMedium: "#BDBDBD",
        grayDark: "#616161",

        // Cores de categoria (usadas em color="catGreen" etc.).
        // Estão no tema do Vuetify — e não como var(--ds-*) — porque a prop
        // `color` não aceita CSS custom property (viraria nome de classe).
        catGreen: "#15803d",
        catTeal: "#0e7490",
        catBlue: "#1d4ed8",
        catAmber: "#b45309",
        catPurple: "#9333ea",
        catViolet: "#6d28d9",
        catCyan: "#0891b2",
        catIndigo: "#4f46e5",
        catOrange: "#ea580c",
        catRed: "#b91c1c",
        catPink: "#be185d",
        catMint: "#0d9488",
        primaryDeep: "#2F7359",
        primarySurface: "#EAF3EE",
      },
      dark: {
        white: "#FFFFFF",
        grayLight: "#E0E0E0",
        grayMedium: "#757575",
        grayDark: "#424242",

        // Espelho clareado das categorias para legibilidade no escuro.
        catGreen: "#4ade80",
        catTeal: "#38bdf8",
        catBlue: "#60a5fa",
        catAmber: "#fbbf24",
        catPurple: "#c084fc",
        catViolet: "#a78bfa",
        catCyan: "#22d3ee",
        catIndigo: "#818cf8",
        catOrange: "#fb923c",
        catRed: "#f87171",
        catPink: "#f472b6",
        catMint: "#2dd4bf",
        primary: "#5CC79E",
        secondary: "#7BD6B3",
        accent: "#E9A857",
        primaryDeep: "#3E9E7B",
        primarySurface: "#17231E",

      },
    },
  },
});
